import React from "react";
import i18n from "../../i18n";
import { Link } from "react-router-dom";

export class Footer extends React.Component {
  render() {
    return (
      <React.Fragment>
        <footer className="bg-dark text-white pt-5 pb-3">
          <div className="container">
            <div className="row">

              {/* Contact & Social */}
              <div className="col-md-3 mb-4  text-start p-5">
                <img
                  src="/assets/images/mzad-footer-logo.png"
                  alt="logo"
                  width="150"
                  className="mb-3"
                />
                <div className="mb-3">
                  <a
                    href="mailto:info@mzadcom.sa"
                    className="d-block text-white text-decoration-none mb-2"
                  >
                    <img
                      src="/assets/images/email-icon.png"
                      alt="email"
                      className="me-2"
                    />
                    info@mzadcom.sa
                  </a>
                  <a
                    href="tel:+96892788822"
                    className="d-block text-white text-decoration-none"
                  >
                    <img
                      src="/assets/images/phone-icon.png"
                      alt="phone"
                      className="me-2"
                    />
                    +968 92 788 822
                  </a>
                </div>
                <div className="d-flex justify-content-start gap-3">
                  <a href="#">
                    <img src="/assets/images/fb-icon.png" alt="facebook" />
                  </a>
                  <a href="#">
                    <img src="/assets/images/x-icon.png" alt="x" />
                  </a>
                  <a href="#">
                    <img src="/assets/images/insta-icon.png" alt="instagram" />
                  </a>
                </div>
              </div>


              {/* Address & Who We Are */}
              <div className="col-md-3 mb-4">
                <h5 className="d-flex align-items-center mb-3 mt-5">
                  <img
                    src="/assets/images/address-icon.png"
                    alt="address"
                    className="me-2"
                  />
                  {i18n.t("address")}
                </h5>
                <p className="small mb-2">
                  Second Floor, Road No.oo.v July Street,
                  <br />
                  AI Ghubra South, P.O.Box Muscat,
                  <br />
                  Sultanate of Oman, Muscat III
                </p>
              </div>


              <div className="col-md-3 mb-4">
                <h5 className="d-flex align-items-center mt-5 mb-3">
                  <img
                    src="/assets/images/who-we-are-icon.png"
                    alt="who-we-are"
                    className="me-2"
                  />
                  {i18n.t("whoweare")}
                </h5>
                <ul className="list-unstyled small">
                  <li className="d-flex align-items-center mb-2">
                    <span className="me-2 text-warning">•</span>
                    <Link
                      to="about/message-chairman"
                      className="text-white text-decoration-none"
                    >
                      {i18n.t("about_mzadcom")}
                    </Link>
                  </li>
                  <li className="d-flex align-items-center mb-2">
                    <span className="me-2 text-warning">•</span>
                    <Link
                      to="services"
                      className="text-white text-decoration-none"
                    >
                      {i18n.t("services")}
                    </Link>
                  </li>
                  <li className="d-flex align-items-center">
                    <span className="me-2 text-warning">•</span>
                    <Link
                      to="contact"
                      className="text-white text-decoration-none"
                    >
                      {i18n.t("contactus")}
                    </Link>
                  </li>
                </ul>
              </div>


              {/* Head Office */}
              <div className="col-md-3 mb-4">
                <h5 className="d-flex align-items-center mb-3">
                
                  <img
                    src="/assets/images/head-office-icon.png"
                    alt="head-office"
                    className="me-2"
                  />
                  {i18n.t("head_office")}
                </h5>
                <div className="border rounded p-2 bg-light text-dark">
                  {/* <img
                    src="/assets/images/map.png"
                    alt="map"
                    className="img-fluid rounded"
                  /> */}

                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1110.6794872709213!2d58.40878987751715!3d23.575830023909585!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ffb71995cfc3%3A0x2af865eda725aadc!2sWorld%20Web%20IT%20Solutions%20L.L.C.%20(Webware)!5e0!3m2!1sen!2som!4v1757762355204!5m2!1sen!2som" width="600"
                    height="450"
                    style={{ border: 0 }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="google-map"
                     className="img-fluid rounded"
                    ></iframe>
                </div>
              </div>

            </div>
          </div>
        </footer>

        {/* Copyright */}
        <div className="text-center py-2 bg-secondary text-white small">
          © {new Date().getFullYear()} mzadcom.sa {i18n.t("all_rights_reserved")}
        </div>

        {/* WhatsApp Floating Button */}
        <button
          className="btn btn-success rounded-circle position-fixed"
          style={{ bottom: "20px", right: "20px", width: "55px", height: "55px" }}
          onClick={() => {
            window.open("https://api.whatsapp.com/send?phone=96892788822", "_blank");
          }}
        >
          <img
            src={process.env.PUBLIC_URL + "/assets/images/messaging.png"}
            height="24"
            width="24"
            alt="WhatsApp"
          />
        </button>
      </React.Fragment>
    );
  }
}
